module.exports = __webpack_public_path__ + "img/flag_gb-sct.ad7b7e6.svg";